import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useStore } from 'react-redux';
import CounterCard from '../../../../components/CounterCard';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';

export default function Stats() {
  const store = useStore();
  const [loading, setLoading] = useState(false);
  const [getStats, setStats]: any = useState<{
    paid?: number;
    due?: number;
    cashPending?: number;
    currentBalance?: number;
  }>({});

  async function fetchAPI() {
    const auth = {
      headers: {
        Authorization: `Bearer ${store.getState().auth.jwt}`,
      },
    };

    const balancePromise = axios.get(`${process.env.REACT_APP_API_SERVER}/balances/current`, auth);
    const pendingPromise = axios.get(`${process.env.REACT_APP_API_SERVER}/balances/pending`, auth);

    balancePromise.then((response) => {
      setStats((prevStats: any) => ({
        ...prevStats,
        currentBalance: response.data.balance,
      }));
    });

    pendingPromise.then((response) => {
      setStats((prevStats: any) => ({
        ...prevStats,
        cashPending: response.data.balance,
      }));
    });
  }

  useEffect(() => {
    fetchAPI();
  }, []);

  return (
    <div>
      <div className="flex flex-wrap w-full">
        {/* <CounterCard
          label={'Cash Collection Pending'}
          count={getStats?.cashPending || 0}
          cardClassName="m-2 w-64"
          icon={<HourglassEmptyIcon style={{ color: '#ff9800' }} />}
          shakeIt={loading}
        /> */}
        <CounterCard
          label={'Pending Balance'}
          count={getStats?.cashPending || 0}
          cardClassName="m-2 w-64"
          icon={<MonetizationOnIcon className="text-orange-500" />}
          shakeIt={loading}
        />
        <CounterCard
          label={'Balance Approved '}
          count={getStats?.currentBalance || 0}
          cardClassName="m-2 w-64"
          icon={<MonetizationOnIcon className="text-green-500" />}
          shakeIt={loading}
        />
        {/* <CounterCard
          label={'Paid'}
          count={getStats?.paid || 0}
          cardClassName="m-2 w-64"
          icon={<AttachMoneyIcon style={{ color: '#4caf50' }} />}
          shakeIt={loading}
        /> */}
      </div>
    </div>
  );
}
